<template>
  <div class="subsector overview">
    <div class="parent-sector">
      <p>Overview</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-sm-12">
          <h1>Emission Projections and Mitigation Potential</h1>
          <p>
            This figure shows the total BAU emission projections (dashed
            line), and residual emissions by sector at various user
            selectable price points. The figure shows that over time non-CO₂
            emissions can be held roughly constant by deploying available
            mitigation technologies (i.e. at higher costs). These emissions
            that remain after mitigation options are implemented are called
            “residual” emissions. Achieving long-term reductions of non-CO₂
            emissions below the 2015 level would require development of new
            or more effective mitigation technologies.
          </p>

          <div class="chartarea">
            <p class="center">
              <button @click="select('btn1')" class="active" id="btn1">$0/tCO₂e</button>
              <button @click="select('btn2')" id="btn2">$5/tCO₂e</button>
              <button @click="select('btn3')" id="btn3">$15/tCO₂e</button>
              <button @click="select('btn4')" id="btn4">$25/tCO₂e</button>
              <button @click="select('btn5')" id="btn5">$50/tCO₂e</button>
              <button @click="select('btn6')" id="btn6">Max Mitigation</button>
            </p>
            <ChartBAU />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BAU from "@/components/json/BAUdata.json";
import $ from "jquery";
import ChartBAU from "./ChartOverviewPopup";
import { EventBus } from "@/event-bus.js";

var WasteData = [],
  AgricultureData = [],
  IPData = [],
  EnergyData = [],
  WasteData5 = [],
  AgricultureData5 = [],
  IPData5 = [],
  EnergyData5 = [],
  WasteData15 = [],
  AgricultureData15 = [],
  IPData15 = [],
  EnergyData15 = [],
  WasteData25 = [],
  AgricultureData25 = [],
  IPData25 = [],
  EnergyData25 = [],
  WasteData50 = [],
  AgricultureData50 = [],
  IPData50 = [],
  EnergyData50 = [],
  WasteData100 = [],
  AgricultureData100 = [],
  IPData100 = [],
  EnergyData100 = [];

for (var i = 0; i < BAU.length; i++) {
  if (BAU[i].Price === "0") {
    if (BAU[i].sector === "Waste") {
      WasteData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }

  if (BAU[i].Price === "5") {
    if (BAU[i].sector === "Waste") {
      WasteData5.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData5.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData5.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData5.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }

  if (BAU[i].Price === "15") {
    if (BAU[i].sector === "Waste") {
      WasteData15.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData15.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData15.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData15.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }

  if (BAU[i].Price === "25") {
    if (BAU[i].sector === "Waste") {
      WasteData25.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData25.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData25.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData25.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }

  if (BAU[i].Price === "50") {
    if (BAU[i].sector === "Waste") {
      WasteData50.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData50.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData50.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData50.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }

  if (BAU[i].Price === "100") {
    if (BAU[i].sector === "Waste") {
      WasteData100.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData100.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData100.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData100.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }
}

export default {
  components: {
    ChartBAU
  },
  props: {
    msg: String
  },
  data() {
    return {
      btn1: true,
      btn2: false,
      btn3: false,
      btn4: false,
      btn5: false,
      btn6: false,
      placeholder: "no data yet"
    };
  },

  methods: {
    handler() {
      var args = arguments;
      for (var arg of args) {
        if (arg instanceof Function) {
          arg();
        }
      }
    },

    select(elem) {
      //alert("selection " + elem);
      $(".subsector button").removeClass("active");

      this.currentView = elem;

      if (this.currentView == "btn1") {
        EventBus.$emit("bau-clicked", {
          newWasteData: WasteData,
          newIPData: IPData,
          newEnergyData: EnergyData,
          newAgricultureData: AgricultureData
        });
        $("#btn1").addClass("active");
      }
      if (this.currentView == "btn2") {
        EventBus.$emit("bau-clicked", {
          newWasteData: WasteData5,
          newIPData: IPData5,
          newEnergyData: EnergyData5,
          newAgricultureData: AgricultureData5
        });
        $("#btn2").addClass("active");
      }
      if (this.currentView == "btn3") {
        EventBus.$emit("bau-clicked", {
          newWasteData: WasteData15,
          newIPData: IPData15,
          newEnergyData: EnergyData15,
          newAgricultureData: AgricultureData15
        });
        $("#btn3").addClass("active");
      }
      if (this.currentView == "btn4") {
        EventBus.$emit("bau-clicked", {
          newWasteData: WasteData25,
          newIPData: IPData25,
          newEnergyData: EnergyData25,
          newAgricultureData: AgricultureData25
        });
        $("#btn4").addClass("active");
      }
      if (this.currentView == "btn5") {
        EventBus.$emit("bau-clicked", {
          newWasteData: WasteData50,
          newIPData: IPData50,
          newEnergyData: EnergyData50,
          newAgricultureData: AgricultureData50
        });
        $("#btn5").addClass("active");
      }
      if (this.currentView == "btn6") {
        EventBus.$emit("bau-clicked", {
          newWasteData: WasteData100,
          newIPData: IPData100,
          newEnergyData: EnergyData100,
          newAgricultureData: AgricultureData100
        });
        $("#btn6").addClass("active");
      }
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../assets/bg-grey-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}

.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.chartarea {
  margin-top: 25px;
  margin-bottom: 25px;
}
.chartarea button {
  position: static;
}
.parent-sector {
  position: static;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
  color: #333;
}
</style>
